<template>
<div>
    <div class="bold mb10" v-if="label">{{label}}</div>
    <div class="flex" v-if="value" style="gap: 5px; flex-wrap: wrap">
        <div class="flex column relative" v-for="i in quantity" :key="`carousel-${i}`">
            <input-image 
            v-model="value[i-1].image"
            :path="imagePath">
            </input-image>
            <div class="flex absolute w100 carousel-controls">
                <i class="icon selectable icon-arrow-left pa10" @click.stop="MoveImage(i-1, -1)" v-show="i > 1" title="Mover"></i>
                <div class="flex-fill"></div>
                <i class="icon selectable icon-arrow-right pa10" @click.stop="MoveImage(i-1, 1)" v-show="i < quantity" title="Mover"></i>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: null,
        },
        label: {
            type: String,
            default: null
        },
        quantity: {
            type: Number,
            default: 4
        },
        imagePath: {
            type: String,
            default: '/',
        }
    },
    mounted() {
        let tmp = this.value;
        if(!tmp) tmp = [];
        while(tmp.length < this.quantity)
            tmp.push({image: null});
        this.$emit('input', tmp);
    },
    methods: {
        MoveImage(index, mov)
        {
            mov = index + mov;
            if(mov < 0) mov = 3;
            if(mov > 3) mov = 0;
            var tmp = this.value[mov];
            this.$set(this.value, mov, this.value[index]);
            this.$set(this.value, index, tmp);
        },
    },
    //TODO: quantity watcher -> resize array
}
</script>

<style>

</style>